import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import EmployeeEnrollmentFields from './EmployeeEnrollmentFields'

export const EmployeeEnrollmentCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <EmployeeEnrollmentFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default EmployeeEnrollmentCreate
